import styled from 'styled-components';

export const TableHeaderItem = styled.th`
  ${props => (props.last || props.alignRight) && 'text-align: right'};
  padding-top: ${props => (props.padding ? props.padding : '10px')};
  padding-bottom: ${props => (props.padding ? props.padding : '10px')};
  padding-right: ${({ selectable }) => selectable && '10px'};
  &:first-child {
    padding-left: 10px;
  }
  &:last-child {
    padding-right: ${({ expand }) => !expand && '10px'};
  }
  &:nth-last-child(2) {
    padding-right: ${({ expand }) => expand && '10px'};
  }
  font-weight: 500;
  width: ${props => props.first && props.fixed && props.firstColumnWidth};
  width: ${({ columnWidth }) => columnWidth && columnWidth};
  cursor: ${({ sortable }) => (sortable ? 'pointer' : 'auto')};

  @media only screen and (max-width: 580px) {
    ${props => (props.mobile ? 'display: table-cell !important' : 'display: none !important')};
    width: ${props => props.first && props.mobileFixed && props.firstColumnWidth};
  }
`;
